const REDACT_PROPERTIES = [
  "firstName",
  "lastName",
  "primaryPhone",
  "dateOfBirth",
  "mobile",
  "email",
  "emailAddress",
  "home",
  "driversLicence",
  "driverLicenseNumber",
  "rewardsCardNumber",
  "cardNumber",
  "accountNo",
  "accountHolderName",
  "street",
  "streetNumber",
  "phone",
  "unitNumber",
  "driverNotes",
  "connectionAddress",
];

/**
 * Mask a value with *.  If its a string it will generate *'s using the string length.
 * Otherwise just 1 *.
 *
 * @param value
 */
const maskValue = (value: any): string => {
  if (typeof value === "string") {
    return new Array(value.length + 1).join("*");
  }
  return "*";
};

/**
 * Recursively goes through the object and masking any PII data.
 *
 * @param obj
 */
const recurseObject = (obj: any) => {
  for (const p in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      const value = obj[p];
      if (value !== null && typeof value === "object") {
        recurseObject(value);
      } else if (REDACT_PROPERTIES.indexOf(p) !== -1) {
        obj[p] = maskValue(value);
      }
    }
  }
};

export const redactObject = (obj: any) => {
  recurseObject(obj);
  return obj;
};
